export default __webpack_public_path__ + "static/media/Diviner's Tunic of Secret Doors.877ddfb2.jpg";